/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SerieLangViewModelPaginatedResponse } from "../types/SerieLangViewModelPaginatedResponse.ts";
import { serieLangViewModelSchema } from "./serieLangViewModelSchema.ts";

export const serieLangViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => serieLangViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<SerieLangViewModelPaginatedResponse>;
